/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Restrict selection to one stable namespace category.
 */
export type PropertySharingExactNamespace = {
    /**
     * Exact namespace selection.
     */
    mode: PropertySharingExactNamespace.mode;
    /**
     * Stored namespace category, including an explicitly absent namespace.
     */
    value: string | null;
};
export namespace PropertySharingExactNamespace {
    /**
     * Exact namespace selection.
     */
    export enum mode {
        EXACT = 'exact',
    }
}

